<script>
import $ from 'domtastic';
import vueMixins from 'viralstyle-ui/src/vueMixins';

export default {
  mixins: [vueMixins],
  props: {
    imageObject: Object,
    sizes: String,
    altText: String,
    backgroundColor: String,
    noPlaceholder: [String, Boolean],
    absolute: [String, Boolean],
    // use only for testing
    testPlaceholder: String,
  },
  data: () => ({
    shouldLoad: false,
    image: new Image(),
  }),
  computed: {
    style() {
      return {
        paddingTop: `${this.imageObject.height / this.imageObject.width * 100}%`,
        backgroundImage: this.noPlaceholder ? null : 'url("' + this.imageObject.placeholder + '")'
      };
    },
  },
  created() {
    $(window).on('scroll', this.$_handleScroll);
    $(window).on('touchmove', this.$_handleScroll);
  },
  mounted() {
    setTimeout(() => this.$_handleScroll(), 1);
  },
  beforeDestory() {
    this.$_detachScrollEvents();
  },
  methods: {
    $_detachScrollEvents() {
      $(window).off('scroll', this.$_handleScroll);
      $(window).off('touchmove', this.$_handleScroll);
    },
    $_handleScroll() {
      if (this.elementEnteredViewPort(this.$el)) {
        if (!this.testPlaceholder) {
          this.shouldLoad = true;
        }

        this.$_detachScrollEvents();
      }
    },
  },
};
</script>

<template lang='pug'>
.progressive-image(:class='absolute ? "absolute" : "relative"', :style='style')
  transition(name='progressive-image')
    img.progressive-image__image(
      v-if='shouldLoad',
      :sizes='sizes',
      :srcset='imageObject.srcSet',
      :src='imageObject.src',
      :alt='altText',
      :style='{ backgroundColor }',
    )
</template>

<style>
@import '~import/index';

.progressive-image {
  @extend %full-width;
  @extend %full-height;
  background-size: cover;

  &__image {
    @extend %full-width;
    @extend %full-height;
    @extend %position-absolute;
    top: 0;
    left: 0;
    opacity: 1;
    object-fit: cover;
  }

  &-enter-active,
  &-leave-active {
    transition: opacity 250ms;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }

  &-leave,
  &-enter-to {
    opacity: 1;
  }
}
</style>